module.exports = __webpack_public_path__ + "static/media/shop-address.152c4d5f.jpg";